"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.fetchAndRepeat = fetchAndRepeat;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _get = _interopRequireDefault(require("lodash/get"));
var _tuner = _interopRequireDefault(require("./tuner"));
var _webApiClientSingleton = _interopRequireDefault(require("./webApiClientSingleton"));
var _Timer = _interopRequireDefault(require("./utils/Timer"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultTtl = 15 * 1000;
var timer = new _Timer["default"]();
var guideId;
var itemToken;
var token;
var onNowPlayingChangedHandler;
var previousNowPlaying;
var fetchNowPlaying;
var useBoostMetadata;
var boostTransitionTitle;

// Exported for testing
function fetchAndRepeat(shouldRepeat) {
  return fetchNowPlaying().then(function (params) {
    if (shouldRepeat) {
      setupNextRequest(shouldRepeat, (0, _get["default"])(params, 'ttl')); // eslint-disable-line no-use-before-define
    }
    return params;
  });
}
function setupNextRequest(shouldRepeat, ttl) {
  timer.start(function () {
    return fetchAndRepeat(shouldRepeat);
  }, ttl || defaultTtl);
}
function maybeApplyBoostMetadata(nowPlaying) {
  if (!nowPlaying.boost) {
    return nowPlaying;
  }
  var _ref = nowPlaying || {},
    _ref$primary = _ref.primary,
    primary = _ref$primary === void 0 ? {} : _ref$primary,
    _ref$boost = _ref.boost,
    boost = _ref$boost === void 0 ? {} : _ref$boost;
  var _ref2 = useBoostMetadata ? boost : primary,
    title = _ref2.title,
    subtitle = _ref2.subtitle,
    image = _ref2.image;
  var _ref3 = !useBoostMetadata ? boost : primary,
    otherSubtitle = _ref3.subtitle;
  return _objectSpread(_objectSpread({}, nowPlaying), {}, {
    title: boostTransitionTitle || title,
    subtitle: boostTransitionTitle ? otherSubtitle : subtitle,
    image: image
  });
}
function onNowPlayingFetched(response) {
  var responseNowPlaying = response.nowPlaying,
    nowPlayingToken = response.token;
  var nowPlaying = maybeApplyBoostMetadata(responseNowPlaying);
  token = nowPlayingToken;

  // We need the boost guide id for reporting, but the Now Playing API is the only one that provides
  // it as of now, so we'll rely on this hacky-feeling logic for now. In the future, if Boost API's
  // change or the boost guide id is added to the Tune API payload, we can update this.
  if (nowPlaying.boost && nowPlaying.boost.guideId) {
    _tuner["default"].boostState.guideId = nowPlaying.boost.guideId;
  }
  if (!previousNowPlaying || previousNowPlaying.title !== nowPlaying.title) {
    previousNowPlaying = nowPlaying;
    onNowPlayingChangedHandler(nowPlaying);
  }
  return nowPlaying;
}
fetchNowPlaying = function fetchNowPlaying() {
  if (!guideId) {
    return Promise.reject();
  }
  return _webApiClientSingleton["default"].instance.profile.nowPlaying(guideId, {
    token: token,
    itemToken: itemToken
  }).then(onNowPlayingFetched)["catch"](_noop["default"]);
};
function poll(id, handler, shouldRepeat) {
  onNowPlayingChangedHandler = handler;
  guideId = id;
  itemToken = _tuner["default"].tune.itemToken;
  return fetchAndRepeat(shouldRepeat);
}
function _stop() {
  timer.clear();
  previousNowPlaying = null;
  guideId = null;
}
var _default = exports["default"] = {
  start: function start(id, handler) {
    return poll(id, handler, true);
  },
  stop: function stop() {
    _stop();
  },
  fetchCurrentNowPlaying: function fetchCurrentNowPlaying(id) {
    return this.fetchOnce(id, _noop["default"]);
  },
  fetchOnce: function fetchOnce(id, handler) {
    return poll(id, handler, false);
  },
  toggleBoostMetadata: function toggleBoostMetadata(trueOrFalse) {
    useBoostMetadata = trueOrFalse;
    boostTransitionTitle = null;
    if (previousNowPlaying) {
      var nextNowPlaying = maybeApplyBoostMetadata(previousNowPlaying);
      onNowPlayingChangedHandler(nextNowPlaying);
    }
  },
  showBoostTransitionTitle: function showBoostTransitionTitle(title) {
    boostTransitionTitle = title;
    if (previousNowPlaying) {
      var nextNowPlaying = maybeApplyBoostMetadata(previousNowPlaying);
      onNowPlayingChangedHandler(nextNowPlaying);
    }
  },
  setRejectReasonKey: function setRejectReasonKey(rejectReasonKey) {
    previousNowPlaying.rejectReasonKey = rejectReasonKey;
    onNowPlayingChangedHandler(previousNowPlaying);
    _stop();
  }
};
//# sourceMappingURL=nowPlayingPoller.js.map